import { render, staticRenderFns } from "./PeriodChange.vue?vue&type=template&id=5524397a&scoped=true&"
import script from "./PeriodChange.vue?vue&type=script&lang=js&"
export * from "./PeriodChange.vue?vue&type=script&lang=js&"
import style0 from "./PeriodChange.vue?vue&type=style&index=0&id=5524397a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5524397a",
  null
  
)

export default component.exports